import { useTranslation } from 'next-i18next'
import { makeStyles, Container, Grid } from '@material-ui/core'
import T from './tokens'
import Reveal from './Reveal'

const steps = [
  {
    img: '/static/img/home-new/steps/step1-create.png',
    w: 535,
    h: 597,
    titleKey: 'steps.step1.title',
    descKey: 'steps.step1.desc',
  },
  {
    img: '/static/img/home-new/steps/step2-payment.png',
    w: 593,
    h: 636,
    titleKey: 'steps.step2.title',
    descKey: 'steps.step2.desc',
  },
  {
    img: '/static/img/home-new/steps/step3-dropoff.png',
    w: 652,
    h: 622,
    titleKey: 'steps.step3.title',
    descKey: 'steps.step3.desc',
  },
]

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '70px 0',
    background: T.color.surface,
    [theme.breakpoints.down('sm')]: {
      padding: '40px 0',
    },
  },
  heading: {
    fontFamily: T.font.heading,
    fontSize: 32,
    fontWeight: 500,
    color: T.color.ink,
    textAlign: 'center',
    margin: '0 0 48px',
    '& span': {
      color: T.color.brand,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
      margin: '0 0 28px',
    },
  },
  stepCard: {
    textAlign: 'center',
    padding: '0 16px',
  },
  // Fixed, uniform box for the step illustrations. The three source images
  // have different aspect ratios (535x597 / 593x636 / 652x622), so at a fixed
  // 280px width they render at DIFFERENT heights (~312 / 300 / 267). Rendering
  // them free would push each column's title-pill + caption to a different Y.
  // Giving every image the same fixed-height box (bottom-aligned, like the
  // mockup) makes all three pills/captions sit at the SAME Y across columns.
  stepImgBox: {
    height: 320,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      height: 240,
    },
  },
  stepImg: {
    width: '100%',
    maxWidth: 280,
    maxHeight: 320,
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'center bottom',
    borderRadius: T.radius.lg,
    transition: 'transform 0.4s ease',
    '&:hover': {
      transform: 'translateY(-8px)',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 200,
      maxHeight: 240,
    },
  },
  stepTitle: {
    fontFamily: T.font.heading,
    fontSize: 20,
    fontWeight: 500,
    margin: '20px 0 8px',
    background: T.gradient.blue,
    color: T.color.onBrand,
    display: 'inline-block',
    padding: '8px 24px',
    borderRadius: T.radius.pill,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
      padding: '6px 18px',
    },
  },
  stepDesc: {
    fontFamily: T.font.body,
    fontSize: 15,
    color: T.color.muted,
    lineHeight: 1.6,
    margin: '12px 0 0',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
}))

const StepsNew = () => {
  const classes = useStyles()
  const { t } = useTranslation('home')

  return (
    <section className={classes.root}>
      <Container maxWidth={false} style={{ maxWidth: T.container }}>
        <Reveal>
          <h2 className={classes.heading}>
            {t('steps.headingBefore')} <span>SHIPPOP</span> {t('steps.headingAfter')}
          </h2>
        </Reveal>
        <Grid container spacing={4} justify="center">
          {steps.map((step, i) => (
            <Grid item xs={12} sm={4} key={step.titleKey}>
              <Reveal delay={i * 0.15}>
                <div className={classes.stepCard}>
                  <div className={classes.stepImgBox}>
                    <picture style={{ display: 'contents' }}>
                      <source
                        srcSet={step.img.replace(/\.png$/, '.webp')}
                        type="image/webp"
                      />
                      <img
                        src={step.img}
                        alt={t(step.titleKey)}
                        className={classes.stepImg}
                        width={step.w}
                        height={step.h}
                        loading="lazy"
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <div className={classes.stepTitle}>{t(step.titleKey)}</div>
                  <p className={classes.stepDesc}>{t(step.descKey)}</p>
                </div>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  )
}

export default StepsNew
